"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableSelectionButton = exports.StyledTableSelectionButtons = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const { primaryBlueMed600 } = ui_components_1.baseColors;
exports.StyledTableSelectionButtons = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  text-decoration: underline;
`;
exports.StyledTableSelectionButton = (0, styled_components_1.default)(ui_components_1.Button) `
  & .MuiButton-label {
    font-size: 0.625rem;
    color: ${primaryBlueMed600};
  }
`;
